export default {
  brandColor1: '#111111',
  complimentaryColor1: '#fff',
  brandColor2: '#c5a653',
  complimentaryColor2: '#fff',
};
